import { createFileRoute } from '@tanstack/react-router';
import { createGroupBroadcastEditRoute } from '@/lib/route-factories/group-broadcast-route';

export const Route = createFileRoute(
  '/_authed/circles/$id/admin/broadcasts/$broadcastId/edit',
)(
  createGroupBroadcastEditRoute({
    kind: 'circle',
    fromId: '/_authed/circles/$id/admin/broadcasts/$broadcastId/edit',
  }),
);
